import React from "react";
import { Head, Card } from "../../../components/template";

const CorporateWellness = () => {
  const programs = [
    {
      title: "THRIVE",
      bestFor: "Corporate Teams",
      gain: "Build stamina, energy, and resilience, create a high-performance well-bonded team culture where employees feel engaged, fulfilled, and unstoppable.",
      image: "/assets/home/Corporate.jpeg",
      link: "/corporate-wellness/thrive",
    },
    {
      title: "INSIGHT",
      bestFor: "Founders, CXOs & Business Leaders",
      gain: "Break free from fatigue, stress, and burnout. Step away from the constant pressure, gain clarity, and return recharged, refocused, and ready to lead with purpose.",
      image: "/assets/thrive/INSIGHT Image.jpeg",
      link: "/corporate-wellness/insight",
    },
  ];

  return (
    <div className="bg-light px-6 py-12">
      <Head
        heading="Corporate Programs"
        subheading="Elevate Leadership. Rethink Productivity. Redefine Performance."
        content={[
          <>
            Leaders and teams are constantly chasing deadlines, handling pressure, and operating in survival mode—only to find themselves running on empty. Burnout is skyrocketing. Productivity is depleting. Motivation is dwindling. Longer hours, forced motivation, and traditional offsites can only produce superficial and short-lived results.
          </>,
        ]}
        subcontent={[
          <>
            <strong>Lasting performance and success</strong> come from a{" "}
            <strong>deeper untapped source</strong> —from harnessing your{" "}
            <strong>intrinsic energy, motivation, and intelligence.</strong>
          </>,
        ]}
      />
      
      {/* Programs Section */}
      <div className="mt-12 space-y-8">
        {programs.map((program, index) => (
          <Card key={index} {...program} />
        ))}
      </div>
    </div>
  );
};

export default CorporateWellness;

